(function() {
  if (window.__brigoCartPreviewLoaded) return;
  window.__brigoCartPreviewLoaded = true;

  var palette = [
    {name:'Gri',hex:'#606783'},
    {name:'Kırmızı',hex:'#BB2028'},
    {name:'Turuncu',hex:'#FF821B'},
    {name:'Siyah',hex:'#000000'},
    {name:'Sarı',hex:'#FFFC01'},
    {name:'Üzüm Moru',hex:'#552A82'},
    {name:'Soğuk Beyaz',hex:'#f0eded'},
    {name:'Yeşil',hex:'#2B6439'},
    {name:'Mavi',hex:'#01378D'},
    {name:'Barbie Pembe',hex:'#FD838E'},
    {name:'Bordo',hex:'#540104'},
    {name:'Kahverengi',hex:'#664033'},
    {name:'Açık Mavi',hex:'#169BEA'},
    {name:'Açık Yeşil',hex:'#38D844'},
    {name:'Holly Yeşil',hex:'#03594E'},
    {name:'Bej',hex:'#FDC094'},
    {name:'Gümüş',hex:'#9C9A9A'},
    {name:'Kemik Beyazı',hex:'#C7B494'},
    {name:'Mor',hex:'#910194'},
    {name:'Koyu Mavi',hex:'#0b0136'},
    {name:'Beton Gri',hex:'#B7B7B5'},
    {name:'Açık Gri',hex:'#7997B3'}
  ];
  var chars='0123456789ABCDEFGHIJKL';

  function decodeChar(ch) {
    return chars.indexOf(ch);
  }

  function renderPreview(wrap) {
    if (!wrap || wrap.dataset.brigoRendered === 'true') return;
    var code = wrap.getAttribute('data-brigo-code') || '';
    if (code.length < 2304) return;

    var canvas = wrap.querySelector('.brigo-cart-preview');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var cell = canvas.width / 48;
    var radius = cell * .455;
    var counts = new Array(palette.length).fill(0);

    ctx.clearRect(0,0,canvas.width,canvas.height);
    ctx.fillStyle='#050505';
    ctx.fillRect(0,0,canvas.width,canvas.height);

    for (var i=0;i<2304;i++) {
      var colorIndex=decodeChar(code.charAt(i));
      if (colorIndex < 0 || colorIndex >= palette.length) colorIndex=3;
      counts[colorIndex]++;

      var x=i%48;
      var y=Math.floor(i/48);
      var cx=x*cell+cell/2;
      var cy=y*cell+cell/2;

      ctx.beginPath();
      ctx.arc(cx+radius*.035,cy+radius*.055,radius,0,Math.PI*2);
      ctx.fillStyle='rgba(0,0,0,.22)';
      ctx.fill();

      ctx.beginPath();
      ctx.arc(cx,cy,radius,0,Math.PI*2);
      ctx.fillStyle=palette[colorIndex].hex;
      ctx.fill();
    }

    var row=wrap.closest('.cart-item');
    var meta=row && row.querySelector('.brigo-cart-colors');
    var summary=row && row.querySelector('.brigo-cart-design-summary');
    var used=[];

    counts.forEach(function(count,index){
      if(count>0) used.push({index:index,count:count});
    });
    used.sort(function(a,b){return b.count-a.count;});

    if(summary) summary.textContent='48 × 48 • 2304 parça • '+used.length+' renk';

    if(meta) {
      meta.innerHTML='';
      used.forEach(function(item){
        var chip=document.createElement('span');
        chip.className='brigo-cart-color-chip';
        chip.title=palette[item.index].name+' • '+item.count+' adet';

        var dot=document.createElement('span');
        dot.className='brigo-cart-color-dot';
        dot.style.background=palette[item.index].hex;

        var name=document.createElement('span');
        name.textContent=palette[item.index].name;

        var count=document.createElement('span');
        count.className='brigo-cart-color-count';
        count.textContent=item.count;

        chip.appendChild(dot);
        chip.appendChild(name);
        chip.appendChild(count);
        meta.appendChild(chip);
      });
    }

    wrap.dataset.brigoRendered='true';
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-brigo-code]').forEach(renderPreview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  } else {
    scan(document);
  }

  var observer=new MutationObserver(function(mutations){
    mutations.forEach(function(mutation){
      mutation.addedNodes.forEach(function(node){
        if(node.nodeType !== 1) return;
        if(node.matches && node.matches('[data-brigo-code]')) renderPreview(node);
        scan(node);
      });
    });
  });

  observer.observe(document.documentElement,{childList:true,subtree:true});
})();